
import { bulkCartService } from "@/services/cartServices";
import { BulkOrderCartState } from "@/types/cart";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState: BulkOrderCartState = {
  cart: null,
  loading: false,
  error: null,
};

// Async Thunks
export const addCart = createAsyncThunk(
  "bulkOrderCart/addCart",
  async (
    data: {
      PhoneNumber: string | null;
      SKU_ID: string;
      quantity: number;
      Type: "ndp" | "sales";
    },
    { rejectWithValue }
  ) => {
    try {
      return await bulkCartService.addCart(data);
    } catch (error: unknown) {
      // Use `unknown` instead of `any`
      if (error instanceof Error) {
        return rejectWithValue(error.message); // Handles standard JS errors
      }
      return rejectWithValue("Error adding to cart"); // Fallback for unknown errors
    }
  }
);

export const updateQuantity = createAsyncThunk(
  "bulkOrderCart/updateQuantity",
  async (
    data: { PhoneNumber: string | null; SKU_ID: string; quantity: number },
    { rejectWithValue }
  ) => {
    try {
      return await bulkCartService.updateQuantity(data);
    } catch (error: unknown) {
      // Use `unknown` instead of `any`
      if (error instanceof Error) {
        return rejectWithValue(error.message); // Handles standard JS errors
      }
      return rejectWithValue("Error updating quantity"); // Fallback for unknown errors
    }
  }
);

export const fetchCart = createAsyncThunk(
  "bulkOrderCart/fetchCart",
  async (PhoneNumber: string | null, { rejectWithValue }) => {
    try {
      return await bulkCartService.fetchCart(PhoneNumber);
    } catch (error: unknown) {
      // Use `unknown` instead of `any`
      if (error instanceof Error) {
        return rejectWithValue(error.message); // Handles standard JS errors
      }
      return rejectWithValue("Error fetching cart"); // Fallback for unknown errors
    }
  }
);

export const removeCart = createAsyncThunk(
  "bulkOrderCart/removeCart",
  async (
    { PhoneNumber, SKU_ID }: { PhoneNumber: string | null; SKU_ID: string },
    { rejectWithValue }
  ) => {
    try {
      return await bulkCartService.removeCart(PhoneNumber, SKU_ID);
    } catch (error: unknown) {
      // Use `unknown` instead of `any`
      if (error instanceof Error) {
        return rejectWithValue(error.message); // Handles standard JS errors
      }
      return rejectWithValue("Error removing from cart"); // Fallback for unknown errors
    }
  }
);

// Slice
const CartSlice = createSlice({
  name: "bulkOrderCart",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.loading = false;
        state.cart = action.payload;
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addCart.pending, (state) => {
        state.error = null;
      })
      .addCase(addCart.fulfilled, () => {})
      .addCase(addCart.rejected, (state, action) => {
        state.error = action.payload as string;
      })
      .addCase(removeCart.fulfilled, () => {});
  },
});

export default CartSlice.reducer;
